import { Typography, styled } from '@mui/material';

export const Wrap = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '16px',
});

export const Logo = styled('img')({
	width: '120px',
	height: '19px',
});

export const Text = styled(Typography)(({ theme }) => ({
	[theme.breakpoints.up('sm')]: {
		textAlign: 'center',
	},
}));
